import { IDocumentFolderWithAccess } from '@api/models';
import { removeUserFromFolder } from '@api/services/document.service';
import { useMutation } from '@tanstack/react-query';

interface RemoveUserFromFolderOptions {
    clientId: string;
    folder: IDocumentFolderWithAccess;
}

const useRemoveUserFromFolderForm = (options: RemoveUserFromFolderOptions) => {
    const { folder, clientId } = options;

    const removeUserFromFolderMutation = useMutation((userId: string) =>
        removeUserFromFolder(clientId, folder._id, userId)
    );

    const submit = async (value: string) => {
        await removeUserFromFolderMutation.mutateAsync(value);
    };

    return {
        isLoading: removeUserFromFolderMutation.isLoading,
        submit,
    };
};

export default useRemoveUserFromFolderForm;
